import { Component, inject, Input, OnInit, ViewChild } from '@angular/core'
import { CommonModule, DatePipe } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { Assistance } from 'src/app/models/assistance'
import { IonicModule, ModalController } from '@ionic/angular'
import { GridAllModule, GridComponent, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids'
import { FinanceService } from '../../../services/domain/finance.service'
import { AssistanceEditorModalService } from '../assistance-editor-modal/assistance-editor-modal.service'
import { Observable } from 'rxjs'
import { AssistanceService } from '../../../services/domain/assistance/assistance.service'
import { AssistanceStatusName } from '../../../models/assistanceStatus'
import { ListAssistanceLockService } from '../assistance-list-new/list-assistance-lock.service'
import { switchMap } from 'rxjs/operators'
import { AssistanceStatusComponent } from '../assistance-status/assistance-status.component'
import { NgxFloatUiModule } from 'ngx-float-ui'

enum SimpleAssistanceListButton {
  bill,
  cancel,
  delete,
}

@Component({
  selector: 'app-simple-assistance-list',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    GridAllModule,
    AssistanceStatusComponent,
    NgxFloatUiModule,
    DatePipe,
  ],
  templateUrl: './simple-assistance-list.component.html',
  styleUrls: ['./simple-assistance-list.component.scss'],
})
export class SimpleAssistanceListComponent implements OnInit {
  private modalCtrl = inject(ModalController)
  private financeService = inject(FinanceService)
  private assistanceEditorModalService = inject(AssistanceEditorModalService)
  private assistanceService = inject(AssistanceService)
  private lockerService = inject(ListAssistanceLockService)

  TAG = 'SimpleAssistanceListComponent'
  @Input() initialAssistances: Assistance[]
  @Input() assistances$: Observable<Assistance[]>
  @Input() headerText: string
  @Input() instructionText: string

  @ViewChild('grid') grid: GridComponent

  assistancesToRender$: Observable<Assistance[]>
  lastClickedButton: SimpleAssistanceListButton = null

  Assistance = Assistance
  BTNS = SimpleAssistanceListButton
  console = console

  async ngOnInit() {
    this.assistancesToRender$ = this.assistances$.pipe(
      switchMap((assistances) => this.lockerService.syncAfterLockChanges$(assistances)),
    )
  }

  close() {
    this.modalCtrl.dismiss()
  }

  rowClicked(event: RowSelectEventArgs) {
    const assistance = this.grid.getSelectedRecords()[0] as Assistance

    if (this.lastClickedButton !== null && this.lastClickedButton !== undefined) {
      switch (this.lastClickedButton) {
        case SimpleAssistanceListButton.bill:
          this.billAssistanceClicked(assistance)
          break
        case SimpleAssistanceListButton.cancel:
          this.cancelAssistanceClicked(assistance)
          break
        case SimpleAssistanceListButton.delete:
          this.deleteAssistanceClicked(assistance)
          break
      }
    } else {
      this.assistanceEditorModalService.openEditor(assistance).then((modal) =>
        modal.onDidDismiss().then((data) => {
          console.log('dismissedModal', data)
          console.log('onDidDismiss')
        }),
      )
    }

    setTimeout(() => {
      this.grid.clearSelection()
      this.clearLastClickedButton()
    })
  }

  async billAssistanceClicked(a: Assistance) {
    await this.lock(a)

    await this.financeService.billAssistances([a])
  }

  async cancelAssistanceClicked(a: Assistance) {
    this.lock(a)

    const alert = await this.assistanceEditorModalService.changeStatusWithDialog(
      a,
      AssistanceStatusName.CANCELED,
      true,
      async (assistanceWithChangedStatus) => {
        a = (await this.assistanceService.update(assistanceWithChangedStatus)) as Assistance
        this.unlock(a)
      },
    )
    await alert.onDidDismiss().then((data) => {
      console.log('dismiss', data)
      if (data.role === 'cancel' || data.role === 'backdrop') this.lockerService.unlock(a)
    })
  }

  async deleteAssistanceClicked(a: Assistance) {
    await this.lock(a)

    await this.assistanceService.deleteWithConfirmation(a)
  }

  buttonClicked(btn: SimpleAssistanceListButton) {
    this.lastClickedButton = btn
  }

  private clearLastClickedButton() {
    this.lastClickedButton = null
  }

  private lock(a: Assistance) {
    this.lockerService.lock(a)
    this.grid.dataSource = { ...this.grid.dataSource }
  }

  private unlock(a: Assistance) {
    this.lockerService.unlock(a)
    this.grid.dataSource = { ...this.grid.dataSource }
  }
}
